import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IFilter, ISignalState } from './interface';
import { IHolding } from '../hooks/useSignalHoldingList';

export const useSignalStore = create<ISignalState>()(
  persist(
    (set, _) => ({
      holdingList: [],
      filterConfig: {
        alertTimes: { start: '', end: '' },
        mc: { start: '', end: '' },
        liquidity: { start: '', end: '' },
        holders: { start: '', end: '' },
      },
      bscSignalTradingSetting: {
        slippage: '',
        slippageAuto: true,
        fee: '',
        feeAuto: true,
        merge: true,
        mev: true,
        alert: true,
        quickBuys: ['0.1', '0.5', '1'],
        quickSells: ['25', '50', '100'],
      },
      solSignalTradingSetting: {
        slippage: '',
        slippageAuto: true,
        fee: '',
        feeAuto: true,
        merge: true,
        mev: true,
        alert: true,
        quickBuys: ['0.1', '0.5', '1'],
        quickSells: ['25', '50', '100'],
      },
      setHoldingList: (holdingList: IHolding[]) => set({ holdingList }),
      setFilterConfig: (filterConfig: { alertTimes: IFilter; mc: IFilter; liquidity: IFilter; holders: IFilter }) => set({ filterConfig }),
      setBscSignalTradingSetting: (bscSignalTradingSetting: ISignalState['bscSignalTradingSetting']) => set({ bscSignalTradingSetting }),
      setSolSignalTradingSetting: (solSignalTradingSetting: ISignalState['solSignalTradingSetting']) => set({ solSignalTradingSetting }),
    }),
    {
      name: 'signal_store',
      partialize: (state) => ({
        bscSignalTradingSetting: state.bscSignalTradingSetting,
        solSignalTradingSetting: state.solSignalTradingSetting,
        filterConfig: state.filterConfig,
      }),
    },
  ),
);
